import React from "react";
import Header from "../include/Header"
import Contents from "../include/Contents"
import Footer from "../include/Footer"
import WrapTitle from "../include/WrapTitle"
import ReferInfo from "../info/ReferInfo"
import ContactInfo from "../include/ContactInfo"
import Loader from "../include/Loader"
import axios from 'axios';



class Reference extends React.Component {

    //데이터 저장소 // 데이터를 감지해서 바꿔줌!
    state = {
        isLoading : true,
        refers : [],
    }




    getRefer = async() => {
        const {
            data: {
                data:{htmlRefer},
            },
        } = await axios.get("https://webstoryboy.github.io/react5001/src/assets/json/refer.json");
        this.setState({htmlRefer, isLoading : false});
        // console.log(htmlRefer)
            
    }



    //생명주기함수 
    componentDidMount(){
        setTimeout(()=>{
            //state값을 바꾸고싶다면 state가 아니라 setState로 작성해야 함
            // this.setState({isLoading : false});
            this.getRefer();
        },2000)
    }

    render(){
        const {isLoading, htmlRefer} = this.state;

        return (
            <div>
                { isLoading ? (
                    <Loader />
                ) : (
                    <div>
                        <Header/>
                        <Contents>
                            <section id="referCont">
                                <div className="container">
                                    <WrapTitle text={["reference","book"]}/>
                                    <div className="refer__cont">
                                        <div className="table">
                                            <h3>HTML</h3>
                                            <ul>
                                                {htmlRefer.map((refer) => (
                                                    <ReferInfo 
                                                        key={refer.id}
                                                        id={refer.id} 
                                                        title={refer.title} 
                                                        desc1={refer.desc1}
                                                        desc2={refer.desc2} 
                                                        use={refer.use} 
                                                        element={refer.element} 
                                                        tag={refer.tag} 
                                                        version={refer.version} 
                                                        view={refer.view} 
                                                        definition={refer.definition} 
                                                    />
                                                ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <ContactInfo />
                        </Contents>
                        <Footer/>
                    </div>
                )}
            </div> 
            
        )
    }
}

export default Reference;